import React, { useState } from 'react';

const defaultValue = {
  categoriaReadOnly: true,
  centroCustoReadOnly: true,
};

export const ConfiguracaoContext = React.createContext({});

export const ConfiguracaoProvider = (props) => {
  return (
    <ConfiguracaoContext.Provider
      value={{
        categoriaReadOnly: useState(defaultValue.categoriaReadOnly),
        centroCustoReadOnly: useState(defaultValue.centroCustoReadOnly),
      }}
    >
      {props.children}
    </ConfiguracaoContext.Provider>
  );
};

export const ConfiguracaoConsumer = ConfiguracaoContext.Consumer;
